import React from "react";

import { isPresent } from "~/tools/is-present";

export interface NoMoreScrollToTopProps {
	text: string;
	/**
	 * @default true if onScrollToTop is provided, otherwise false
	 */
	displayScrollToTop?: boolean;
	onScrollToTop?: () => void;
}

export const NoMoreScrollToTop: React.FC<NoMoreScrollToTopProps> = ({
	text,
	onScrollToTop,
	displayScrollToTop = isPresent(onScrollToTop),
}) => (
	<div className="text-sm tracking-normal">
		{text}
		{displayScrollToTop && isPresent(onScrollToTop) && (
			<a
				className="pl-1 hocus:text-grey-500 text-grey-500 underline hocus:no-underline"
				href={undefined}
				onClick={() => onScrollToTop()}
			>
				Scroll back to top
			</a>
		)}
	</div>
);
